import {apiClient} from "./api/ApiClient";

type time = number;
type item_id = string;

/** Dynamic getter: reads from remote config with compile-time fallback */
const getInterAdAllowed = () => {
    if (__SOCIAL__ !== "tg") return true;
    return apiClient.configValue("inter_ad_enabled", false);
};

export const SIOConstants = {
    INTER: "159047249520140_192930072798524",
    REWARD: "159047249520140_192930196131845",
    BANNER_PLACEMENT: "159047249520140_192929926131872",
    PLACEMENTS: {},
    CLAIM_FACTOR: 3,
    BANNER_HEIGHT: __SOCIAL__ === "gd" ? 90 : 70,
    MAX_REWARD_CAP_IN_MS: 43200000,
    MIN_OFFLINE_EARNINGS_PERIOD_IN_MIN: 5,
    COINS_REWARD_FOR_INVITE: 1000,
    REWARD_AD_PLAYED: new Map<item_id, time>(),
    IN_GAME_AUDIO_CONTROL_ALLOWED: true,
    REWARDED_AD_ALLOWED: true,
    get INTER_AD_ALLOWED() { return getInterAdAllowed(); },
    OFFLINE_EARNINGS_ALLOWED: true,
    HARD_VERSION: (() => {
        return __SOCIAL__ === "yt" ? "30082023" : "";
    })(),
    LEADERBOARD_ENABLED: __SOCIAL__ === "gd" ? false : true
};
